module.exports = __webpack_public_path__ + "c2b363a14f399653c8ac31a5bd3dde74.svg";